import { coreApi } from './coreApi';

export type CoreApiTagTypes = 'apartment-admin' | 'site-settings';

export const enhancedCoreApi = coreApi.enhanceEndpoints<CoreApiTagTypes>({
  endpoints: {
    updateSiteGsmService: {
      invalidatesTags: [
        { id: 'site', type: 'site-settings' },
        { id: 'apartment-detail', type: 'apartment-admin' },
      ],
    },
  },
});
